var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedErrorNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF004A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0062 26.0044C11.9597 26.0068 8.31066 23.5703 6.76183 19.832C5.213 16.0937 6.0697 11.7905 8.93216 8.93037C11.4595 6.40308 15.1431 5.41606 18.5954 6.34111C22.0478 7.26617 24.7444 9.96276 25.6694 13.4151C26.5945 16.8675 25.6075 20.5511 23.0802 23.0784C21.2076 24.9594 18.6603 26.013 16.0062 26.0044ZM8.00616 16.1764C8.05348 20.5776 11.6473 24.1139 16.0487 24.0904C20.4501 24.0666 24.0057 20.4919 24.0057 16.0904C24.0057 11.6889 20.4501 8.11415 16.0487 8.09037C11.6473 8.06683 8.05348 11.6031 8.00616 16.0044V16.1764ZM13.4152 20.0044L12.0062 18.5944L14.5962 16.0044L12.0062 13.4144L13.4162 12.0044L16.0062 14.5944L18.5962 12.0044L20.0062 13.4144L17.4162 16.0044L20.0062 18.5944L18.5972 20.0044L16.0062 17.4144L13.4162 20.0044H13.4152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedErrorNotification);
export default __webpack_public_path__ + "static/media/red-error-notification.9fed75a63261d25b27d589bad6f649db.svg";
export { ForwardRef as ReactComponent };